var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @desc geo component
 */
import { createRef } from '@byted/light-render';
import GeoCoord from '../../coord/geo';
import { CompoundPath, Group, Polygon, Polyline, Rect, createText, } from '../../element';
import Zoomable from '../../element/zoomable';
import { ComponentModel } from '../../model';
import * as lodash from '../../utils/lodash';
import { decode } from './mapUtil';
var registeredMaps = {};
export function registerMap(name, json) {
    registeredMaps[name] = json;
}
/**
 * default export
 */
var GeoMap = /** @class */ (function (_super) {
    __extends(GeoMap, _super);
    function GeoMap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'geo';
        _this.handleDragStart = function () {
            if (!_this.option.panning) {
                return;
            }
            _this.setState({ isPanning: true });
        };
        _this.handleDragMove = function (event) {
            if (!_this.option.panning) {
                return;
            }
            if (_this.state.isZooming) {
                return;
            }
            var dx = event.dx, dy = event.dy;
            var position = _this.state.position;
            if (!_this.state.isPanning && (dx > 5 || dy > 5)) {
                _this.handleDragStart();
                return;
            }
            position[0] += dx;
            position[1] += dy;
            _this.setState({ position: position });
            _this.refreshUI();
        };
        _this.handleDragEnd = function () {
            if (!_this.option.panning) {
                return;
            }
            setTimeout(function () {
                _this.setState({ isPanning: false });
            }, 0);
        };
        _this.refreshUI = function () {
            var _a;
            (_a = _this.getRenderObj()) === null || _a === void 0 ? void 0 : _a.setAttr({
                position: _this.state.position,
                scale: [_this.state.scale, _this.state.scale],
            });
            _this.state.regions.forEach(function (region) {
                if (region.labelRef.current) {
                    region.labelRef.current.setAttr({
                        fontSize: _this.option.label.fontSize / _this.state.scale,
                    });
                }
            });
            _this.chart.dispatchAction({
                type: 'map:roam',
                position: _this.state.position,
                scale: _this.state.scale,
            });
        };
        _this.handleZoom = function (event) {
            if (!_this.option.zooming) {
                return;
            }
            var origin = event.origin, zoom = event.zoom;
            var x = origin[0], y = origin[1];
            var _a = _this.state, scale = _a.scale, position = _a.position;
            var nextScale = scale * zoom;
            var scaleDiff = nextScale - scale;
            if (nextScale <= 0) {
                return;
            }
            position[0] -= ((x - position[0]) / scale) * scaleDiff;
            position[1] -= ((y - position[1]) / scale) * scaleDiff;
            position[0] += event.position[0];
            position[1] += event.position[1];
            _this.setState({
                scale: nextScale,
                position: position,
            });
            _this.refreshUI();
        };
        _this.handleMapMouseEnter = function (event) {
            _this.toggleHighlightRegion(event.region, true);
        };
        _this.handleMapMouseLeave = function (event) {
            _this.toggleHighlightRegion(event.region, false);
            // const target = event.region.regionRef.current;
            // if (event.region.labelRef.current) {
            //   event.region.labelRef.current.setAttr({
            //     display: this.option.label.show,
            //     ...this.getTextStyle(this.option.label),
            //     fontSize: this.option.label.fontSize / this.state.scale,
            //   });
            // }
            // const attr = {
            //   ...this.getShapeStyle(this.option.shapeStyle),
            //   fill: event.region.color,
            // };
            // if (target.type === 'group') {
            //   (target as Group).children().forEach(child => {
            //     child.setAttr(attr);
            //   });
            // } else {
            //   target.setAttr(attr);
            // }
        };
        _this.handleRegionEvent = function (event, region) {
            _this.handleUIEvent(event, 'region', {
                name: region.name,
                region: region,
            });
            if (region.data) {
                _this.chart.eachSeriesModel(function (model) {
                    if (model.type === 'map') {
                        model.handleUIEvent(event, 'point', region.data);
                    }
                });
            }
        };
        return _this;
    }
    GeoMap.prototype.getDefaultOption = function () {
        return {
            facet: 0,
            zooming: false,
            panning: false,
            map: '',
            nameMap: {},
            shapeStyle: {
                fill: '#F0F2F6',
                stroke: '#CCD0E1',
                lineWidth: 1,
            },
            label: {
                show: false,
                fontSize: 12,
                color: '#333333',
                position: 'inside',
                distance: 4,
            },
            hover: {
                shapeStyle: {
                    stroke: null,
                    lineWidth: null,
                },
                label: {
                    show: false,
                    fontSize: 12,
                    color: '#333333',
                    position: 'inside',
                    distance: 4,
                },
            },
            selected: {
                shapeStyle: {
                    stroke: null,
                    lineWidth: null,
                },
            },
        };
    };
    GeoMap.prototype.getInitialState = function () {
        return {
            position: [0, 0],
            scale: 1,
            regions: [],
            isPanning: false,
            isZooming: false,
        };
    };
    GeoMap.prototype.init = function () {
        var _this = this;
        var allSeries = this.chart.getAllSeries();
        var mapSeries = allSeries.filter(function (seriesModel) { return seriesModel.getOption().type === 'map'; });
        if (mapSeries.length > 0) {
            lodash.merge(this.option, lodash.pick(mapSeries[0], ['label', 'shapeStyle', 'hover', 'selected']));
        }
        this._dragEventRect = new Rect({
            draggable: true,
            key: this.getKey('evnet-rect'),
            fill: '#ffffff',
            getDragOffset: function () {
                return { x: 0, y: 0 };
            },
            onDrag: this.handleDragMove,
            onDragEnd: this.handleDragEnd,
        });
        this.chart.getRenderInstance().addEventElement(this._dragEventRect);
        this._zoomInstance = new Zoomable(this._dragEventRect, {
            onZoomStart: function () { return _this.setState({ isZooming: true }); },
            onZooming: this.handleZoom,
            onZoomEnd: function () { return _this.setState({ isZooming: false }); },
        });
        this.registerEvent('region:mouseenter', this.handleMapMouseEnter);
        this.registerEvent('region:mouseleave', this.handleMapMouseLeave);
    };
    GeoMap.prototype.beforeRender = function () {
        var _this = this;
        var nameMap = this.option.nameMap;
        var _a = this.chart.getFacetContentBox(this.option.facet), top = _a.top, left = _a.left, width = _a.width, height = _a.height;
        var boundRect = { x: left, y: top, width: width, height: height };
        var mapData = decode(registeredMaps[this.option.map], this.option.map);
        this._coordGeo = new GeoCoord(boundRect, mapData);
        var regions = mapData.features.map(function (feature) {
            var name = feature.properties.name;
            return {
                name: nameMap[name] || feature.properties.name,
                center: feature.properties.center || feature.properties.cp,
                feature: feature,
                color: _this.option.shapeStyle.fill,
                labelRef: createRef(),
                regionRef: createRef(),
                selected: false,
                data: null,
            };
        });
        this._dragEventRect.setAttr(__assign({}, boundRect));
        this.setState({ regions: regions });
        this.option.zooming ? this._zoomInstance.enable() : this._zoomInstance.disable();
        this._dragEventRect.setAttr({
            draggable: this.option.panning,
        });
    };
    GeoMap.prototype.beforeDestroy = function () {
        this.chart.getRenderInstance().removeEventElement(this._dragEventRect);
        this._zoomInstance.destroy();
    };
    GeoMap.prototype.getCoordinate = function () {
        return this._coordGeo;
    };
    GeoMap.prototype.renderLineString = function () {
        return new Polyline();
    };
    GeoMap.prototype.toggleHighlightRegion = function (region, active) {
        var _a;
        var _b = this.option, label = _b.label, hoverLabel = _b.hover.label;
        var labelRefCurrent = region.labelRef.current;
        var regionRefCurrent = region.regionRef.current;
        labelRefCurrent === null || labelRefCurrent === void 0 ? void 0 : labelRefCurrent.setAttr(__assign(__assign(__assign({ display: active ? hoverLabel.show : label.show }, this.getTextStyle(this.option.label)), (active ? this.getTextStyle(this.option.hover.label) : null)), { fontSize: label.fontSize / this.state.scale }));
        if (active) {
            (_a = regionRefCurrent === null || regionRefCurrent === void 0 ? void 0 : regionRefCurrent.parentNode) === null || _a === void 0 ? void 0 : _a.add(regionRefCurrent);
        }
        regionRefCurrent === null || regionRefCurrent === void 0 ? void 0 : regionRefCurrent.setAttr(__assign(__assign(__assign(__assign({}, this.getShapeStyle(this.option.shapeStyle)), { fill: region.color }), (region.selected ? this.getShapeStyle(this.option.selected.shapeStyle) : null)), (active ? this.getShapeStyle(this.option.hover.shapeStyle) : null)));
    };
    GeoMap.prototype.toggleSelectRegion = function (region, selected) {
        var _a;
        region.selected = selected;
        (_a = region.regionRef.current) === null || _a === void 0 ? void 0 : _a.setAttr(this.getRegionStyle(region));
    };
    GeoMap.prototype.renderPolygon = function (region, geometry) {
        var _this = this;
        var multiPointList = geometry.coordinates.map(function (coords) {
            return coords.map(function (coord) {
                return _this._coordGeo.dataToPoint({
                    lng: coord[0],
                    lat: coord[1],
                });
            });
        });
        return new CompoundPath(__assign(__assign({ key: region.name, shapes: multiPointList.map(function (pointList) { return new Polygon({ pointList: pointList }); }) }, this.getRegionStyle(region)), { transitionProperty: 'none', strokeNoScale: true, onEvent: function (event) { return _this.handleRegionEvent(event, region); } }));
    };
    GeoMap.prototype.renderMultiPolygon = function (region, geometry) {
        var _this = this;
        var pathList = [];
        geometry.coordinates.forEach(function (coordsList, index) {
            var multiPointList = coordsList.map(function (coords) {
                return coords.map(function (coord) {
                    return _this._coordGeo.dataToPoint({
                        lng: coord[0],
                        lat: coord[1],
                    });
                });
            });
            pathList.push(new CompoundPath({
                key: region.name + "child" + index.toString(),
                shapes: multiPointList.map(function (pointList) { return new Polygon({ pointList: pointList }); }),
            }));
        });
        return new CompoundPath(__assign(__assign({ shapes: pathList }, this.getRegionStyle(region)), { transitionProperty: 'none', strokeNoScale: true, onEvent: function (event) { return _this.handleRegionEvent(event, region); } }));
    };
    GeoMap.prototype.getRegionStyle = function (region) {
        return __assign(__assign(__assign({}, this.getShapeStyle(this.option.shapeStyle)), { fill: region.color }), (region.selected ? this.getShapeStyle(this.option.selected.shapeStyle) : null));
    };
    GeoMap.prototype.renderMultiLineString = function () {
        return new Group({});
    };
    GeoMap.prototype.renderGeometryCollection = function () {
        return new Group({});
    };
    GeoMap.prototype.renderRegion = function (region) {
        var geometry = region.feature.geometry;
        var geo;
        if (geometry.type === 'LineString') {
            geo = this.renderLineString();
        }
        else if (geometry.type === 'MultiLineString') {
            geo = this.renderMultiLineString();
        }
        else if (geometry.type === 'Polygon') {
            geo = this.renderPolygon(region, geometry);
        }
        else if (geometry.type === 'MultiPolygon') {
            geo = this.renderMultiPolygon(region, geometry);
        }
        else if (geometry.type === 'GeometryCollection') {
            geo = this.renderGeometryCollection();
        }
        geo.setAttr('ref', region.regionRef);
        return geo;
    };
    GeoMap.prototype.renderRegions = function () {
        var _this = this;
        var group = new Group({
            key: this.getKey('geo-feature'),
        });
        this.state.regions.forEach(function (region) { return group.add(_this.renderRegion(region)); });
        return group;
    };
    GeoMap.prototype.renderLabels = function () {
        var _this = this;
        var formatter = this.option.label.formatter;
        var group = new Group({
            key: this.getKey('geo-label'),
        });
        this.state.regions.forEach(function (region) {
            var center = region.center, name = region.name, data = region.data, selected = region.selected;
            if (!center || !name) {
                return;
            }
            var _a = _this._coordGeo.dataToPoint({
                lng: center[0],
                lat: center[1],
            }), x = _a.x, y = _a.y;
            var label = createText(__assign(__assign({ ref: region.labelRef, display: _this.option.label.show, text: formatter
                    ? formatter((data ? data.point : { name: name, selected: selected }))
                    : name, x: x,
                y: y, textAlign: 'center', textBaseline: 'middle' }, _this.getTextStyle(_this.option.label)), { fontSize: _this.option.label.fontSize / _this.state.scale, pointerEvents: 'none', transitionProperty: 'none' }));
            group.add(label);
        });
        return group;
    };
    GeoMap.prototype.render = function () {
        var _a = this.state, position = _a.position, scale = _a.scale;
        var group = new Group({
            key: this.getKey('geo'),
            position: position,
            scale: [scale, scale],
        });
        group.add(this.renderRegions());
        group.add(this.renderLabels());
        return group;
    };
    GeoMap.dependencies = [];
    return GeoMap;
}(ComponentModel));
export default GeoMap;
